import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../UserContext';
import { MenuItems } from './MenuItems';
import logo from '../../assets/images/logo.png';
import logoText from '../../assets/images/logo-text.png';
import coinImg from '../../assets/images/coin-img.png';
import useMatchMedia from '../utils/useMatchMedia';
import { useLocation, useHistory } from 'react-router-dom';
import { Amplify, Auth } from 'aws-amplify';
import { Hub } from '@aws-amplify/core';
import awsconfig from '../../aws-exports';
import { cx } from '@emotion/css';
import * as styles from './navbar.style';
import { Link } from 'react-router-dom';
import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/animation_llwbajur.json';
import { LocationContext } from '../../reducers/LocationContext';
import { SubscriptionContext } from '../../reducers/SubscriptionContext';
import Modal from 'react-modal';

Amplify.configure(awsconfig);

// Bind modal to app element for accessibility
Modal.setAppElement('#root');

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

function Navbar() {
  const { user, setUser } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [loadingstatus, setLoadingstatus] = useState(false);
  const { isMobile } = useMatchMedia();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isChallengesDropdownOpen, setIsChallengesDropdownOpen] = useState(false);
  const { subscriptionStatus, remainingTime } = useContext(SubscriptionContext);
  const { countryCode } = useContext(LocationContext);
  const [displayTime, setDisplayTime] = useState(remainingTime);
  const history = useHistory();
  const location = useLocation();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  // Sync displayTime with remainingTime when remainingTime changes
  useEffect(() => {
    setDisplayTime(remainingTime);
  }, [remainingTime]);

  // Update displayTime every second
  useEffect(() => {
    if (!remainingTime || subscriptionStatus !== "active") return;

    const interval = setInterval(() => {
      setDisplayTime((prevTime) => {
        if (!prevTime) return prevTime;

        let { days, hours, minutes, seconds } = prevTime;

        seconds -= 1;
        if (seconds < 0) {
          seconds = 59;
          minutes -= 1;
        }
        if (minutes < 0) {
          minutes = 59;
          hours -= 1;
        }
        if (hours < 0) {
          hours = 23;
          days -= 1;
        }
        if (days < 0) {
          return null;
        }
        // console.log("Updated display time:", { days, hours, minutes, seconds });

        return { days, hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [remainingTime, subscriptionStatus]);

  // Detect subscription expiration and show modal, unless on root, localhost, or public routes
  useEffect(() => {
    // console.log("subscriptionStatus:", subscriptionStatus); // Debug subscription status
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const isRootPath = location.pathname === '/';
    const publicRoutes = [
      '/',
      '/terms',
      '/privacy',
      '/refund',
      '/expired',
      '/login',
      '/logout',
      '/maps',
      '/subscription',
      '/success',
      '/cancel',
      '/settings',
      '/practice',
      '/practicequiz'
    ];
    const isPublicRoute = publicRoutes.includes(location.pathname);
    if (subscriptionStatus === "expired" && !modalIsOpen && !isLocalhost && !isRootPath && !isPublicRoute) {
      // console.log("Showing modal: subscription expired, not on public route or localhost");
      setModalIsOpen(true);
    }
  }, [subscriptionStatus, location.pathname, modalIsOpen]);

  // Close modal and optionally redirect to subscription page
  const handleModalClose = (redirect = false) => {
    // console.log("Modal closed, redirect:", redirect); // Debug modal close
    setModalIsOpen(false);
    if (redirect) {
      history.push("/subscription");
    }
  };

  const getToken = async () => {
    setLoading(true);
    try {
      const user = await Auth.currentAuthenticatedUser();
      const res = await Auth.currentSession();
      let accessToken = res.getAccessToken();
      let jwt = accessToken.getJwtToken();

      if (accessToken.payload.username.includes("Google_")) {
        await CreatorUpdateUser(accessToken.payload.username, user.attributes['email'], jwt);
      } else {
        await CreatorUpdateUser(accessToken.payload.username, accessToken.payload.username, jwt);
      }
    } catch (err) {
      // console.error("Error in getToken:", err);
    } finally {
      setLoading(false);
    }
  };

  const getTokenByEvent = async (data) => {
    setLoading(true);
    setLoadingstatus(true);
    switch (data.payload.event) {
      case 'signIn': {
        getToken();
        break;
      }
      case 'signOut': {
        setUser({});
        setLoadingstatus(false);
        setLoading(false);
        break;
      }
      default:
        break;
    }
    setLoading(false);
  };

  const CreatorUpdateUser = async (username, email, jwt) => {
    if (username.includes('Google')) {
      username = email;
    }
    const now = new Date();
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({
        username: username,
        score: 1000,
        appname: 'QuizWhiz',
        reloadedpoints: 1000,
        canbeprivate: true,
        grade: 5,
        timezone: 'UTC-5',
        birthdate: '2000-01-01',
        parent: false,
        parentname: ' ',
        parentnamerequestedname: '',
        customizequestions: false,
        parentnamerequested: false,
        profilepic: 'defaultavatar',
        premiumuser: 0,
        friendslist: [],
        friendsrequestlist: [],
        sendrequestlist: [],
        friendnamerequested: false,
        rewardslist: [],
        crown: '',
        user_created_time: now.toUTCString(),
        availableavatars: [
          'boy1', 'girl1', 'boy2', 'girl2', 'boy3', 'girl3', 'boy4', 'girl4',
          'boy5', 'girl5', 'boy6', 'girl6', 'boy7', 'girl7', 'boy8', 'girl8',
          'boy9', 'girl9', 'boy10', 'girl10',
        ],
        nextbooster: 10,
        nextunlockkey: 5,
        unlockkeys: 0,
        boosters: 0,
        batchlist: [],
        gold: 0,
        id: username,
      }),
    };
    const response = await fetch(`https://api.prod.quizwizard.net/quiz/createorupdateuser`, requestOptions);
    const data = await response.json();

    if (data["isnewuser"]) {
      history.push('/settings');
    }

    setUser(data);
  };

  const getuserDetails = async (username, jwt) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({ username: username }),
    };

    const response = await fetch(`https://api.prod.quizwizard.net/quiz/getuser`, requestOptions);
    const data = await response.json();

    setUser(data);
  };

  useEffect(() => {
    Hub.listen('auth', getTokenByEvent);
    getToken();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isOpen) setIsOpen(false);
  }, [location]);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleChallengesDropdown = (e) => {
    e.stopPropagation();
    setIsChallengesDropdownOpen(!isChallengesDropdownOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
    setIsChallengesDropdownOpen(false);
  };

  useEffect(() => {
    document.body.addEventListener('click', closeDropdown);
    return () => {
      document.body.removeEventListener('click', closeDropdown);
    };
  }, []);

  const handlePremiumLinkClick = (e) => {
    e.preventDefault();
    history.push("/subscription");
  };

  return (
    <header className={`header ${cx(styles.header, { [styles.scrolled]: scrolled })}`}>
      {isMobile && (
        <button
          onClick={() => setIsOpen(true)}
          className={cx(styles.navBtn)}
          type="button"
        >
          <img src={require('../../assets/images/menu.png').default} alt="" />
        </button>
      )}
      <Link className={cx(styles.headerLogo)} to="/">
        <img src={isMobile ? logo : logoText} alt="" />
      </Link>
      <nav
        className={`${isMobile ? cx(styles.navMobile) : cx(styles.nav)}${isOpen ? ' is-open' : ''}`}
      >
        {isMobile && (
          <button
            onClick={() => setIsOpen(false)}
            className={cx(styles.navCloseBtn)}
            type="button"
          >
            <img src={require('../../assets/images/close.png').default} alt="" />
          </button>
        )}
        {MenuItems.map((item) => (
          <div
            className={`${cx(styles.navItem)}${item.subMenu ? ' dropdown' : ''}`}
            key={item.title}
          >
            {item.subMenu ? (
              <a className={cx(styles.navLink)} onClick={toggleChallengesDropdown}>{item.title}</a>
            ) : (
              <Link className={cx(styles.navLink)} to={item.url}>
                {item.title}
              </Link>
            )}
            {item.subMenu && (
              <div className={`${cx(styles.navSubMenu)} dropdown-menu ${isChallengesDropdownOpen ? 'is-active' : ''}`}>
                {item.subMenu.map((subItem) => (
                  <Link
                    key={subItem.title}
                    className={cx(styles.navSubLink)}
                    to={subItem.url}
                  >
                    {subItem.title}
                  </Link>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>
      <div className={cx(styles.rightPanel)}>
        {loading ? (
          <Lottie options={defaultOptions} height={200} width={200} style={{ clipPath: "inset(10% 10% 30% 10%)" }} />
        ) : Object.keys(user).length ? (
          <>
            <div className={cx(styles.coin)}>
              <img src={coinImg} alt="" />
              <div>{user['score']} Points</div>
            </div>
            <div className={`${cx(styles.profile)} dropdown`} onClick={toggleDropdown}>
              <a>
                <img
                  src={
                    user['profilepic'] &&
                    require(`../../assets/images/${user['profilepic']}.jpg`).default
                  }
                  alt=""
                />
              </a>
              <div className={`${cx(styles.settingsMenu)} dropdown-menu ${isDropdownOpen ? 'is-active' : ''}`}>
                <a className={cx(styles.profileLink, 'no-hover')}>
                  Hi {user.username}
                </a>
                <a
                  className={cx(styles.profileLink)}
                  onClick={handlePremiumLinkClick}
                  style={{ cursor: 'pointer' }}
                >
                  <span style={{
                    color: subscriptionStatus === "active" && displayTime ? "gold" : "inherit",
                    marginRight: "8px"
                  }}>
                    <img src="/assets/crown7.png" alt="Logo" />
                  </span>
                  {subscriptionStatus === "active" && displayTime
                    ? (
                      <>
                        Subscriptions
                        <span style={{
                          display: "inline-block",
                          backgroundColor: "rgba(212, 244, 80, 0.76)",
                          color: "green",
                          borderRadius: "12px",
                          padding: "2px 8px",
                          fontSize: "0.8em",
                          marginLeft: "8px",
                          fontWeight: "bold",
                          border: "1px solid rgba(12, 12, 12, 0.5)"
                        }}>
                          {displayTime ? (displayTime.days === 0 ? "Last Day" : `${displayTime.days}d left`) : "Expired"}
                        </span>
                      </>
                    )
                    : "Get Premium"}
                </a>
                <Link className={cx(styles.profileLink)} to="/premiumdashboard">
                  <img
                    src={require('../../assets/images/icon-dashboard.png').default}
                    alt="Dashboard"
                  />
                  Transactions
                </Link>
                <Link className={cx(styles.profileLink)} to="/settings">
                  <img
                    src={require('../../assets/images/icon-settings.png').default}
                    alt=""
                  />
                  Settings
                </Link>
                <Link className={cx(styles.profileLink)} to="/logout">
                  <img
                    src={require('../../assets/images/icon-logout.png').default}
                    alt=""
                  />
                  Logout
                </Link>
              </div>
            </div>
          </>
        ) : (
          !loadingstatus && (
            <div className={cx(styles.loginbtn1)}>
              <Link className={cx(styles.loginbtn)} to="/login">
                Login
              </Link>
            </div>
          )
        )}
      </div>
      {/* <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => handleModalClose(false)}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            padding: '20px',
            borderRadius: '10px',
          },
        }}
      >
        <h2>Subscription Expired</h2>
        <p>Your subscription has expired. Please renew to continue accessing premium features.</p>
        <div style={{ marginTop: '20px' }}>
          <button
            onClick={() => handleModalClose(true)}
            style={{
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              marginRight: '10px',
            }}
          >
            Go to Subscription
          </button>
          <button
            onClick={() => handleModalClose(false)}
            style={{
              padding: '10px 20px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>
      </Modal> */}
    </header>
  );
}

export default Navbar;